import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function Home() {
  return (
    <>
      <Header />

      <section className="position-relative d-flex justify-content-center align-items-center">
        <div className="w-100 p-0 overflow-hidden">
          <div className="marquee-wrap pt-0 pb-1">
            <div className="loop-track">
              <div className="loop-collection">
                {[1, 2, 3, 4, 5, 6, 7].map((num) => (
                  <img
                    key={num}
                    src={`/assets/images/slider/${num}.png`}
                    className="rounded-4 marquee-image"
                  />
                ))}
                {[1, 2, 3, 4, 5, 6, 7].map((num) => (
                  <img
                    key={`dup-${num}`}
                    src={`/assets/images/slider/${num}.png`}
                    className="rounded-4 marquee-image"
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="marquee-wrap pb-1">
            <div className="loop-track-fast">
              <div className="loop-collection">
                {[8, 9, 10, 11, 12, 13, 1].map((num) => (
                  <img
                    key={num}
                    src={`/assets/images/slider/${num}.png`}
                    className="rounded-4 marquee-image"
                  />
                ))}
                {[8, 9, 10, 11, 12, 13, 1].map((num) => (
                  <img
                    key={`dup-${num}`}
                    src={`/assets/images/slider/${num}.png`}
                    className="rounded-4 marquee-image"
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="marquee-wrap">
            <div className="loop-track">
              <div className="loop-collection">
                {[10, 7, 6, 2, 13, 8, 1].map((num) => (
                  <img
                    key={num}
                    src={`/assets/images/slider/${num}.png`}
                    className="rounded-4 marquee-image"
                  />
                ))}
                {[10, 7, 6, 2, 13, 8, 1].map((num) => (
                  <img
                    key={`dup-${num}`}
                    src={`/assets/images/slider/${num}.png`}
                    className="rounded-4 marquee-image"
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="marquee-wrap pb-1 d-lg-none d-block">
            <div className="loop-track-fast">
              <div className="loop-collection">
                {[2, 9, 10, 6, 4, 12, 5].map((num) => (
                  <img
                    key={num}
                    src={`/assets/images/slider/${num}.png`}
                    className="rounded-4 marquee-image"
                  />
                ))}
                {[2, 9, 10, 6, 4, 12, 5].map((num) => (
                  <img
                    key={`dup-${num}`}
                    src={`/assets/images/slider/${num}.png`}
                    className="rounded-4 marquee-image"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="position-absolute">
          <div className="container p-6 d-flex justify-content-center">
            <div className="col-lg-8 col-12 text-center">
              <h2 className="display-6 text-light opacity-75 fw-medium ls-sm">
                Your face is the key. Visualaey does the rest.
              </h2>
              <h1 className="display-4 text-white fw-semibold ls-sm lh-1 mt-2">
                Revolutionize Face Recognition with
                <br />
                AI-Powered Photo Sharing
              </h1>
              <p class="my-3 h3 lh-sm text-light lead fw-light opacity-75">
                Visualaey's strength goes beyond our clever tools. We're
                anchored in one of the largest and most supportive AI
                communities worldwide, and we're deeply committed to it.
              </p>
              <div class="mt-5">
                <Link
                  to="/search"
                  class="btn btn-light px-6 btn-md rounded-pill"
                >
                  Where’s My Face ?
                </Link>
                <Link
                  to="/pricing"
                  class="btn btn-outline-light ms-1 px-6 btn-md rounded-pill"
                >
                  Our Pricing
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-1">
        <div className="container pt-6 d-flex justify-content-center">
          <div className="col-lg-8 col-12 text-center">
            <div>
              <div class="avatar-group">
                {[8, 9, 10, 11, 12, 13, 1].map((num) => (
                  <span className="avatar avatar-xl" key={num}>
                    <img
                      alt={`avatar-${num + num}`}
                      src={`/assets/images/slider/${num}.png`}
                      className="rounded-circle"
                    />
                  </span>
                ))}
              </div>
            </div>

            <h2 className="display-5 text-white fw-medium ls-sm mt-2">
              <span className="colorful-text">+1.8 Million Users</span> using
              Visualaey
            </h2>
            <p class="mb-3 h3 lh-sm text-light lead fw-light opacity-75">
              Discover how millions effortlessly find their event photos with
              just one selfie. Visualaey makes photo sharing smart, instant, and
              personal.
            </p>

            <div className="d-flex justify-content-center mt-5">
              <Link
                to="/signup"
                className="btn border-1 border-light text-white fw-normal d-none d-md-block me-2 px-5 me-lg-0 rounded-pill"
              >
                Create Account
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section class="position-relative z-1 mt-lg-8 mt-5 mb-7">
        <div class="container">
          <div class="row align-items-center g-0 bg-dark-1 rounded-5 overflow-hidden">
            <div class="col-lg-7 col-12">
              <div className="m-5 rounded-5 p-lg-5 p-3">
                <h2 class="text-white fw-medium ls-sm mt-2 mb-3">
                  <span class="">Gallery Powered</span> by your face
                </h2>
                <p class="lead text-white opacity-75 mb-5 fw-normal lh-sm">
                  Visualaey is an AI powered, cloud native platform that
                  automatically finds and delivers every photo you're in, just
                  by uploading a selfie.
                </p>
                <div class="">
                  <Link
                    to="login"
                    class="btn btn-light px-6 btn-md rounded-pill"
                  >
                    Get Started
                  </Link>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-12">
              <img
                src="/assets/images/14.jpg"
                className="w-100 rounded-end-5 object-fit-cover"
                height="320"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-hero overflow-hidden pb-8">
        <div className="row justify-content-center">
          <div className="col-lg-3 col-12">
            <img
              src="/assets/images/5.jpg"
              className="w-100 rounded-5 object-fit-cover transform-rotateZ mt-6 d-lg-block d-none"
              height="300"
            />
          </div>
          <div className="col-lg-6 p-6 col-12 text-center mt-n5">
            <h1 className="display-5 text-white fw-semibold ls-sm lh-1 mt-lg-8 mb-2">
              Capture. Upload. Discover Instantly.
            </h1>
            <h2 className="fs-3 text-light opacity-75 fw-normal ls-sm lh-sm mt-3 mb-lg-0 mb-7 pb-lg-0 pb-3">
              Welcome to the future of event photo sharing. A cloud native, AI
              driven platform that makes organizing and discovering your
              memories effortless.
            </h2>
            <div className="d-flex justify-content-center mt-5">
              <Link
                to="/signup"
                className="btn border-1 border-light text-white fw-normal d-none d-md-block me-2 px-5 me-lg-0 rounded-pill"
              >
                Create Account
              </Link>
              <Link
                to="/features"
                className="btn border-0 text-white fw-normal d-none d-md-block me-2 px-5 me-lg-0 rounded-pill ms-2"
              >
                About Visualaey
              </Link>
            </div>
          </div>
          <div className="col-lg-3 col-12">
            <img
              src="/assets/images/3.jpg"
              className="w-100 rounded-5 object-fit-cover transform-rotateY ms-8 mt-4 d-lg-block d-none"
              height="300"
            />
          </div>

          <div className="col-lg-9 col-12 mt-n8">
            <img
              src="/assets/images/9.jpg"
              className="w-100 rounded-5 object-fit-cover transform-rotateX"
              height="500"
            />
          </div>
        </div>
      </section>

      <section class="pt-lg-8 mt-3 pb-lg-3 py-5">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 col-12">
              <div class="pe-lg-6">
                <span className="badge bg-white-soft rounded-pill fs-5 px-4 mb-2">
                  Facial recognition and{" "}
                  <span className="fw-bold">deep learning</span>
                </span>
                <h1 class="display-5 text-light fw-bold my-3 ls-sm lh-1">
                  Let Every Guest Find Their Moments Instantly
                </h1>
                <p class="mb-3 h3 lh-1 text-light fw-normal opacity-75">
                  Whether you're hosting a wedding, birthday, corporate event,
                  or reunion, our clever technology helps you and your guests
                  instantly find every photo they appear in, without ever
                  tagging a single face.
                </p>
                <div class="mt-3">
                  <div class="mb-2">
                    <div>
                      <p class="mb-3 fs-4 lh-sm text-white opacity-50">
                        Our platform matches your face across thousands of high
                        resolution photos and delivers your captured memories in
                        seconds.
                      </p>
                    </div>
                  </div>
                </div>
                <Link
                  to="/book-demo"
                  class="btn btn-white px-5 btn-md mt-3 mb-lg-0 mb-5"
                >
                  Book a Demo
                </Link>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12">
              <img
                src="/assets/images/11.jpg"
                class="object-fit-cover w-100 rounded-5"
                height="400"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="pt-5 bg-image pb-8 my-8">
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-12 py-7">
              <div className="position-relative z-3 d-flex flex-column align-items-center justify-content-center">
                <h1 className="display-5 ls-sm m-0 fw-semibold text-white text-center">
                  Personalized Galleries Powered by AI
                </h1>
                <p className="mb-5 display-6 lh-1 mt-2 text-white ls-sm text-center fw-normal">
                  Our clever AI finds your face with consistent accuracy,
                  handling different lighting, angles, and photo qualities
                  smoothly.
                </p>
                <Link
                  to="/contact"
                  class="btn border border-light text-white rounded-pill px-6 btn-md"
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-lg-2 pb-lg-3 py-2 mb-lg-6 mb-4">
        <div class="container mt-2">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 col-12">
              <img
                src="/assets/images/2.jpg"
                class="object-fit-cover w-100 rounded-5"
                height="400"
              />
            </div>
            <div class="col-lg-6 col-md-12 col-12">
              <div class="ps-lg-6">
                <span className="badge bg-white-soft rounded-pill fs-5 px-4 mb-2 mt-lg-0 mt-5">
                  Memories Effortless
                </span>

                <h2 class="text-white my-3 ls-sm lh-1 fw-normal">
                  A cloud-native, AI-driven platform that makes organizing and
                  discovering memories effortless
                </h2>
                <p class="mb-3 h3 lh-1 text-white opacity-75 fw-normal">
                  Transform how you capture, organize, and share event memories.
                  Say goodbye to endless scrolling and manual sorting, and hello
                  to a new era of intelligent photo sharing.
                </p>
                <div class="mt-5">
                  <div class="mb-2">
                    <div>
                      <p class="mb-3 fs-4 lh-sm">
                        Your first 3 events are completely free, no credit card
                        required. Perfect for testing the platform during your
                        next event. When you're ready for more, upgrade to a
                        simple, affordable subscription plan.
                      </p>
                    </div>
                  </div>
                </div>
                <Link
                  to="/pricing"
                  class="btn btn-outline-light px-5 btn-md mt-4 mb-lg-0 mb-5"
                >
                  Visualaey Pricing
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pb-7">
        <div class="container mb-2">
          <div class="row">
            <div class="col-12">
              <div class="row text-center d-flex justify-content-center">
                <div class="col-lg-7 col-md-12 px-lg-8 mb-3">
                  <h1 class="fw-bold text-white mb-0">
                    Looking for more{" "}
                    <u class="text-white">
                      <span class="text-white">details?</span>
                    </u>
                  </h1>
                  <p class="lead text-white opacity-75 lh-sm mt-2">
                    Our FAQs are filled with helpful insights, handy tips, and
                    all the details you need about Visualaey.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-lg-10 pb-lg-0 pb-3 d-flex align-items-center">
              <div
                class="accordion accordion-flush w-100 pe-lg-5 pe-0 me-lg-5 me-0"
                id="accordionFlushExample"
              >
                <div class="accordion-item mt-1">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                    >
                      <h3 class="fs-4 text-dark fw-medium m-0">
                        How does Visualaey work?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-light opacity-75 lh-sm">
                        Visualaey uses clever AI to match your face and find
                        every photo you're in across the event. You simply
                        upload a selfie, and our AI instantly gathers all your
                        moments. No manual tagging, ever.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item mt-1">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                    >
                      <h3 class="fs-4 text-dark fw-medium m-0">
                        Is the platform secure and private?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    class="accordion-collapse collapse show"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-light opacity-75 lh-sm">
                        Yes, your privacy matters deeply to us. We use industry
                        standard protocols (OAuth 2.0 and JWT) and full
                        encryption to keep your data safe. Your facial data is
                        processed securely, never stored, shared, or sold.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item mt-1">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                    >
                      <h3 class="fs-4 text-dark fw-medium m-0">
                        What types of events is Visualaey best for?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-light opacity-75 lh-sm">
                        From weddings and sangeets to birthdays, corporate
                        galas, reunions, and festivals, Visualaey fits any
                        gathering where cameras are snapping and memories are
                        waiting to be found.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item mt-1">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFour"
                      aria-expanded="false"
                      aria-controls="flush-collapseFour"
                    >
                      <h3 class="fs-4 text-dark fw-medium m-0">
                        How many events can I create for free?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFour"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-light opacity-75 lh-sm">
                        Your first 3 events are completely free, no credit card
                        required, with full access to every feature. After that,
                        you can easily upgrade to a simple and flexible
                        subscription plan that grows with your events.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-6 text-center">
              <Link to="/contact" class="lead lh-1">
                More questions? Contact Us{" "}
                <i className="bi bi-arrow-right fs-4 ms-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-lg-2 pb-lg-3 bottom-bg overflow-hidden">
        <div class="container py-8">
          <div class="row align-items-center pt-2">
            <div class="col-lg-6 col-md-12 col-12">
              <div class="pe-lg-6">
                <span className="badge bg-white-soft rounded-pill fs-5 px-4 mb-2">
                  Visualaey
                </span>

                <h2 class="fw-semibold text-white my-3 ls-sm lh-1">
                  Your Event in Your Pocket. Discover Every Photo Right from
                  Your Phone.
                </h2>
                <div class="mt-3">
                  <div class="mb-2">
                    <div>
                      <p class="mb-3 fs-4 lh-sm text-light opacity-75">
                        Experience the power of Visualaey on mobile, designed
                        for effortless access on the go. Guests can simply
                        upload a selfie and instantly view a personalized
                        gallery of every photo they appear in, right from their
                        smartphone.
                      </p>
                    </div>
                    <div>
                      <p class="mb-0 fs-4 lh-sm text-light opacity-75">
                        Encryption from end to end and secure user
                        authentication keep your memories private and protected.
                      </p>
                    </div>
                  </div>
                </div>
                <Link
                  to="/signup"
                  class="btn btn-light px-6 rounded-pill btn-md mt-5 mb-lg-0"
                >
                  Register Now
                </Link>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12 d-flex justify-content-end">
              <div className="d-flex justify-content-center">
                <img
                  src="/assets/images/13.jpg"
                  class="object-fit-cover rounded-circle me-n8 d-lg-block d-none"
                  height="350"
                  width="350"
                />
                <img
                  src="/assets/images/12.jpg"
                  class="object-fit-cover rounded-circle ms-n5 d-lg-block d-none"
                  height="350"
                  width="350"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Home;
